import { useIntl } from 'react-intl';
import { canvasService } from '../../../apiServices/CanvasService';
import { ConfirmModal } from '../../../components/Modal/ConfirmModal';
import { useUser } from '../../../context/User/useUser';

type CopyProjectModalProps = {
  canvasId: string;
  canvasName: string;
};

export const CopyProjectModal = ({
  canvasId,
  canvasName,
}: CopyProjectModalProps) => {
  const { fetchUser } = useUser();
  const intl = useIntl();

  const onCopyProject = () =>
    canvasService.copyCanvas(canvasId).then((response) => {
      fetchUser();
      return response.message;
    });

  return (
    <ConfirmModal
      title={intl.formatMessage({ id: 'copyProject.title' })}
      description={intl.formatMessage({ id: 'copyProject.description' })}
      confirmLabel={intl.formatMessage({ id: 'copyProject.submitButton' })}
      confirmingLabel={intl.formatMessage({ id: 'copyProject.loading' })}
      cancelLabel={intl.formatMessage({ id: 'copyProject.cancelButton' })}
      onConfirm={onCopyProject}
    >
      <p>
        {intl.formatMessage(
          { id: 'copyProject.confirm' },
          { name: <strong>{canvasName}</strong> }
        )}
      </p>
    </ConfirmModal>
  );
};
